import { SelectOption } from "../components/common/Select";

export enum WorkoutLevel {
    Beginner = 'Beginner',
    Intermediate = 'Intermediate',
    Advanced = 'Advanced',
    TB360 = 'TB360',
}

export const WORKOUT_LEVELS = Object.values(WorkoutLevel);

export const WORKOUT_LEVEL_OPTIONS: SelectOption<WorkoutLevel>[] = WORKOUT_LEVELS.map((level) => ({
    label: level,
    value: level,
}));
  